<template>
  <v-app>
    <!--編輯-->
    <v-dialog v-model="isVisible"
              no-click-animation
              max-width="80%">
      <v-card>
        <v-card-title>{{getTitle}}</v-card-title>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs6>
              <v-select :items="getBankList"
                          item-text="value"
                          item-value="key"
                          v-model="editedItem.bankId"
                          label="嘉好相關銀行列表"
                          background-color='#49bcfd'
                          outline
                ></v-select>
            </v-flex>
            <v-flex xs6>
              <v-text-field
                    :label="getTransactionTitle"
                    v-model="editedItem.price"
                    type="number"
                    background-color='#49bcfd'
                    outline></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap v-if="getFavoriteBankList.length">
            <v-flex>
              <v-select :items="getFavoriteBankList"
                          item-text="value"
                          item-value="key"
                          v-model="targetBankId"
                          label="常用交易帳戶"
                          background-color='#49bcfd'
                          outline
                ></v-select>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
              <v-flex xs6>
                <v-autocomplete :items="getBankInfo"
                                item-text="branch"
                                item-value="key"
                                v-model="officialItem.bankId"
                                :label="`交易對象銀行`"
                                background-color='#49bcfd'
                                @change="setBankInfo"
                                outline
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6>
                <v-autocomplete :items="getBankSubInfo"
                                item-text="branch"
                                item-value="code"
                                v-model="officialItem.bankSubId"
                                label="交易對象銀行分行"
                                background-color='#49bcfd'
                                @change="setBankInfo"
                                outline
                ></v-autocomplete>
            </v-flex>
          </v-layout>
          <v-layout row wrap >
            <v-flex xs6>
              <v-text-field
                    v-model="editedItem.targetName"
                    :label="`交易對象戶名`"
                    background-color='#49bcfd'
                    outline></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-text-field
                    v-model="editedItem.targetAccount"
                    :label="`交易對象帳號`"
                    background-color='#49bcfd'
                    outline></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex>
              <v-select :items="getAgentList"
                          item-text="displayName"
                          item-value="agentId"
                          v-model="editedItem.agentId"
                          label="登入人員"
                          background-color='#49bcfd'
                          outline
                ></v-select>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex>
              <!-- <v-date-picker v-model="editedItem.transactionDate" :label="`匯款日期`"></v-date-picker> -->
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :return-value.sync="editedItem.transactionDate"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="editedItem.transactionDate"
                    label="匯款日期"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="editedItem.transactionDate"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    dark
                    text
                    color="red"
                    @click="menu = false"
                  >
                    取消
                  </v-btn>
                  <v-btn
                    dark
                    text
                    color="primary"
                    @click="$refs.menu.save(editedItem.transactionDate)"
                  >
                    確定
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>
          <v-layout row wrap >
            <v-flex>
              <v-text-field
                    v-model="editedItem.comment"
                    :label="`備註`"
                    background-color='#49bcfd'
                    outline></v-text-field>
            </v-flex>
          </v-layout>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red" dark text @click="closeEvent">取消</v-btn>
            <v-btn class="primary" dark text @click="confirmEvent">確定</v-btn>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>
    <alert-view :visible="messageDialog.visible"
                  :title="messageDialog.title"
                  :content="messageDialog.text"
                  @confirmEvent="messageDialog.confirm"></alert-view>
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import AlertView from '@/components/AlertView';

const bankCodeList = require('../assets/bank_data.json');

export default {
  name: 'CashFlowDialog',
  components: {
    AlertView
  },
  props: {
    visible: Boolean,
    item: Object,
    caseTypeList:Array,
    bankItemList:Array,
    favoriteBankItemList:Array,
    type:Number,
    isNew: Boolean
  },
  data() {
    return {
      loading: false,
      isVisible: false,
      menu: false,
      officialItem:{
        bankId:'',
        bankSubId:''
      },
      messageDialog: {
        title: "",
        text: "",
        visible: false,
        confirm: () => {},
        cancel: () => {},
      },
      targetBankId:'',
    };
  },
  async created() {
    this.fetchAgentList().then(res=>{});
  },
  watch:{
    visible(value){
      this.isVisible = value;
    },
    isVisible(value) {
      if(!value) {
        this.closeEvent()
      }
    },
    targetBankId(value){
      if (value !== ''){
        const find = this.favoriteBankItemList.find(b=>b.bankId === this.targetBankId);
        console.log(`targetBankId ${JSON.stringify(find)}`);
      }
    }
  },
  computed:{
    ...mapGetters(['getUserInfo','getAgentList']),
    isAdmin() {
      return this.getUserInfo.authority === 'admin';
    },
    editedItem() {
      return this.item
    },
    getBankInfo(){
      let bankCopyList= JSON.parse(JSON.stringify(bankCodeList));
      let list = [];
      Object.keys(bankCopyList).forEach(key=>{
        const bankInfo = bankCopyList[key];
        bankInfo.branch = `(${key})${bankInfo.branch}`
        bankInfo.key = key;
        if (bankInfo.child.length > 0){
          list.push(bankInfo);
        }
      });
      return list;
    },
    getBankList() {
      let list = []
      if(!this.bankItemList || !this.bankItemList.length) {
        return list
      }
      this.bankItemList.forEach(element => {
        const info = {
          key: element.bankId,
          value: `${element.title} ${element.subTitle} ${element.account} ${element.name}`
        }
        list.push(info)
      })
      return list
    },
    getFavoriteBankList(){
      let list = []
      if (!this.favoriteBankItemList || !this.favoriteBankItemList.length) {
        return list;
      }

      this.favoriteBankItemList.forEach(element => {
        const info = {
          key: element.bankId,
          value: `${element.title} ${element.subTitle} ${element.account} ${element.name}`
        }
        list.push(info)
      })
      return list
    },
    getBankSubInfo(){
      let list = [];
      let bankInfo = bankCodeList[this.officialItem.bankId];

      if (bankInfo){
        bankInfo.child.forEach(info=>{
          let copyItemInfo = {};
          Object.assign(copyItemInfo,info);
          copyItemInfo.branch = `(${info.code})${info.branch}`
          copyItemInfo.code = info.code.substring(3, info.code.length);
          list.push(copyItemInfo);
        });
      }
      return list;
    },
    getTransactionTitle() {
      return this.type === 0 ?`匯款金額`: `存入金額`
    },
    getTitle () {
      const actionTitle = this.isNew ? `新增` : `編輯`
      const actionSubTitle =  this.type === 0 ? `匯款` : `存入`

      return  `${actionTitle} ${actionSubTitle} 紀錄`
    }
  },
  methods: {
    ...mapActions(['fetchAgentList']),
    setBankInfo() {
      let bankInfoList = bankCodeList[this.officialItem.bankId];
      this.editedItem.targetTitle = this.officialItem.bankId
      const array = bankInfoList.child.filter(element => element.code === `${this.officialItem.bankId}${this.officialItem.bankSubId}`)
      this.editedItem.targetSubTitle = array.length ? this.officialItem.bankSubId : ''
    },
    confirmEvent(){
      if (this.checkFormData()) {
        this.editedItem.type = this.type
        this.$emit('confirmEvent', this.editedItem);
      }
    },
    checkFormData(){
      if(!this.editedItem.bankId) {
        this.showMessageDialog('錯誤', '請選擇嘉好相關銀行！', true, () => {
          }, () => {
        })
        return false
      }
      if(!this.editedItem.price) {
        this.showMessageDialog('錯誤', '請輸入交易金額！', true, () => {
          }, () => {
        })
        return false
      }

      if(this.editedItem.type === 0){
        if(!this.editedItem.targetTitle) {
          this.showMessageDialog('錯誤', '請選擇交易對象銀行！', true, () => {
            }, () => {
          })
          return false
        }

        if(!this.editedItem.targetSubTitle) {
          this.showMessageDialog('錯誤', '請選擇交易對象銀行！', true, () => {
            }, () => {
          })
          return false
        }
        if(!this.editedItem.targetName) {
          this.showMessageDialog('錯誤', '請輸入交易對象戶名！', true, () => {
            }, () => {
          })
          return false
        }
        if(!this.editedItem.targetAccount) {
          this.showMessageDialog('錯誤', '請選擇交易對象帳號！', true, () => {
            }, () => {
          })
          return false
        }
      }
      return true
    },
    closeEvent() {
      this.$emit('closeEvent');
    },
    showMessageDialog(title, text, visible, confirmEvent, cancelEvent) {
      this.messageDialog.title = title;
      this.messageDialog.text = text;
      this.messageDialog.visible = visible;
      const self = this;
      this.messageDialog.confirm = () => {
        self.messageDialog.visible = false;
        if (confirmEvent) {
          confirmEvent();
        }
      };

      this.messageDialog.cancel = () => {
        self.messageDialog.visible = false;
        if (cancelEvent) {
          cancelEvent();
        }
      };
    },
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/CashFlowDialog.vue